import React from 'react';
import { FormGenericContainer } from '../FormGenericContainer';
import { BubbleButton, BubbleAlert } from '../BubbleUI';
import { GroupForm } from './Workflows';

interface BookingConfirmationPageProps {
  title?: string;
  pageIndex?: number;
  isNewGroup: boolean;
  groupForm: GroupForm;
  onGoStart?: () => void;
  onClose?: () => void;
}

export default function BookingConfirmationPage(props: BookingConfirmationPageProps) {
  return (
    <div className="tflf-3">
      <FormGenericContainer
        footer={() => (
          <>
            <div className="text-slate-dark mr-auto"></div>
            {props.onGoStart && (
              <BubbleButton variant="navy" inverse onClick={props.onGoStart}>
                Restart
              </BubbleButton>
            )}
          </>
        )}
      >
        <div className="flex items-start mb-5">
          <div className="mr-auto">
            <h1
              className="text-lg text-slate-dark font-semibold"
              dangerouslySetInnerHTML={{ __html: props.title || 'Create Group Booking' }}
            />
            <h2 className="text-2xl text-navy">
              {props.pageIndex !== undefined ? `${props.pageIndex}. ` : ''}Enter Group Booking
              Details
            </h2>
          </div>
          <BubbleButton
            className="p-1-i"
            variant="navy"
            inverse
            onClick={props.onClose}
            icon="xmark-large"
            iconSize="xl"
          />
        </div>
        <BubbleAlert variant="lime">
          <span className="font-semibold">The booking was submitted!</span> To create another
          similar booking, click the <span className="font-semibold">Restart</span> button.
          Otherwise, you may close the panel.
        </BubbleAlert>
      </FormGenericContainer>
    </div>
  );
}
